import qs from 'qs';

export default search => {
  const params = qs.parse(search.slice(1));
  return dispatch => {
    dispatch({ type: 'LOAD_PARAMS', params });
    if (params.preload != null) {
      fetch('data/state.json', { credentials: 'same-origin' })
        .then(d => d.json())
        .then(state => {
          dispatch({ type: 'PRELOAD', state });
        });
    }
  };
};



// WEBPACK FOOTER //
// ./src/actions/load-params.js